import { Component } from '@angular/core';

@Component({
  selector: 'app-attori',
  templateUrl: './attori.component.html',
  styleUrls: ['./attori.component.scss']
})
export class AttoriComponent {

}
